export default "__VITE_ASSET__C1Gc9peO__"